import api from "./api";

const paymentService = {
  // Get payments by order ID
  getPaymentsByOrder: async (orderId) => {
    try {
      const response = await api.get(`/api/payments/order/${orderId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching payments by order:", error);
      throw error;
    }
  },

  // Get payments by customer ID
  getPaymentsByCustomer: async (customerId, filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.payment_status)
        params.append("payment_status", filters.payment_status);
      if (filters.start_date) params.append("start_date", filters.start_date);
      if (filters.end_date) params.append("end_date", filters.end_date);

      const response = await api.get(
        `/api/payments/customer/${customerId}?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching payments by customer:", error);
      throw error;
    }
  },

  // Get payment summary
  getPaymentSummary: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.customer_id)
        params.append("customer_id", filters.customer_id);
      if (filters.order_id) params.append("order_id", filters.order_id);
      if (filters.start_date) params.append("start_date", filters.start_date);
      if (filters.end_date) params.append("end_date", filters.end_date);

      const response = await api.get(
        `/api/payments/summary?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching payment summary:", error);
      throw error;
    }
  },

  // Get all payments (for admin/vendor)
  getAllPayments: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.payment_status)
        params.append("payment_status", filters.payment_status);
      if (filters.start_date) params.append("start_date", filters.start_date);
      if (filters.end_date) params.append("end_date", filters.end_date);
      if (filters.payment_mode)
        params.append("payment_mode", filters.payment_mode);
      if (filters.customer_id)
        params.append("customer_id", filters.customer_id);
      if (filters.order_id) params.append("order_id", filters.order_id);
      if (filters.payment_id) params.append("payment_id", filters.payment_id);
      if (filters.search) params.append("search", filters.search);
      if (filters.limit) params.append("limit", filters.limit);
      if (filters.offset) params.append("offset", filters.offset);

      const response = await api.get(`/api/payments/all?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching all payments:", error);
      throw error;
    }
  },

  // Download invoice
  downloadInvoice: async (orderId) => {
    try {
      const response = await api.get(`/api/payments/invoice/${orderId}`, {
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("Error downloading invoice:", error);

      // If error response is a blob (JSON error), parse it
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const jsonError = JSON.parse(text);
          // Create a new error with the parsed message
          const customError = new Error(
            jsonError.message || "Failed to download invoice"
          );
          customError.response = {
            ...error.response,
            data: jsonError,
          };
          throw customError;
        } catch (parseError) {
          // If parsing fails, throw original error
          throw error;
        }
      }

      throw error;
    }
  },
};

export default paymentService;
